<div>
  <div
    class="text-right m-2"
    *ngIf="currentPath == '/doqfy/cat-execution/form' && !contractType"
  >
    <p class="text_p">
      Try
      <a
        [routerLink]="['/doqfy/bulk-upload/form', 'cat-upload']"
        class="btn-link clickable link_text"
        trackClick="click_bulk_upload_cat_upload"
      >
        Bulk Upload </a
      >if you have more than 5 E-stamp (or) E-sign.
    </p>
  </div>

  <form [formGroup]="estampDetails">
    <div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="default-flex">
            <h5 class="title_five">E-Stamp details</h5>

            <div
              *ngIf="showEstampSettings && isEstamped && !isDraft"
              class="flex_row ms-4"
            >
              <span class="form_field me-3">E-Stamp Settings : </span>
              <div
                class="flex_row p-field-radiobutton radio_btn ms-1 me-2"
                pTooltip="Will populate the values which are present in setting E-Stamping Details"
                tooltipPosition="bottom"
              >
                <input
                  type="radio"
                  id="default"
                  name="toBeDefault"
                  [(ngModel)]="isDefault"
                  [value]="true"
                  formControlName="toBeDefault"
                  (change)="tobeDefault(true)"
                />
                <label class="me-1 ms-1 form_field" for="default"
                  >Default</label
                >
              </div>
              <div
                class="flex_row p-field-radiobutton radio_btn ms-3 me-4"
                pTooltip="Will Need to Enter the E-Stamp values Manually"
                tooltipPosition="bottom"
              >
                <input
                  type="radio"
                  id="custom"
                  name="toBeDefault"
                  [(ngModel)]="isDefault"
                  [value]="false"
                  formControlName="toBeDefault"
                  (change)="tobeDefault(false)"
                />
                <label class="me-1 ms-1 form_field" for="custom">Custom</label>
              </div>
            </div>
          </div>

          <!-- To be stamped or not -->
          <div
            class="row mt-3"
            *ngIf="!pathId && !contractType && service != 'MULTIPLE-STAMP'"
          >
            <p style="font-size: 0.8rem">
              Do you want the Document to be stamped ?
            </p>
          </div>
          <div
            class="flex_row"
            *ngIf="!pathId && !contractType && service != 'MULTIPLE-STAMP'"
          >
            <div class="flex_row p-field-radiobutton radio_btn ms-1">
              <input
                type="radio"
                id="estampedYes"
                name="toBeEStamped"
                [(ngModel)]="isEstamped"
                (click)="tobeEstamped(true)"
                formControlName="toBeEStamped"
                [value]="true"
              />
              <label class="me-1 ms-1 font_size_12" for="estampedYes"
                >Yes</label
              >
            </div>
            <div class="flex_row p-field-radiobutton radio_btn ms-3">
              <input
                type="radio"
                id="estampedNo"
                name="toBeEStamped"
                [(ngModel)]="isEstamped"
                (click)="tobeEstamped(false)"
                formControlName="toBeEStamped"
                [value]="false"
              />
              <label class="me-1 ms-1 font_size_12" for="estampedNo">No</label>
            </div>
          </div>
          <!-- To be stamped or not -->

          <div
            *ngIf="pathId || service == 'MULTIPLE-STAMP'"
            class="row form_inputFields mt-2"
          >
            <div class="col-lg-4 col-sm-12 col-md-6 estamp">
              <span class="form_field">
                {{
                  showHdfcFields
                    ? "File number (As per HDFC Bank Sanction letter)"
                    : "Reference Number"
                }}</span
              ><span class="color_red">*</span>
              <input
                placeholder="Reference Number"
                class="form-control"
                [ngClass]="enableRefIdField ? '' : 'grey_background'"
                formControlName="referenceNumber"
                pInputText
                type="text"
                (paste)="onPasteEstampInput($event, 'referenceNumber')"
                onkeypress="
                  return (
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) ||
                    (event.charCode >= 48 && event.charCode <= 57) ||
                    event.charCode === 45 ||
                    event.charCode === 95
                  );
                "
                [readOnly]="!enableRefIdField"
                (paste)="onReferencePaste($event)"
              />
              <span
                class="p-error"
                style="font-size: 0.8rem"
                *ngIf="
                  submitted &&
                  estampDetails.get('referenceNumber')?.hasError('required')
                "
                >*Enter reference number</span
              >
              <span
                class="p-error"
                style="font-size: 0.8rem; display: block; padding-top: 0.2rem"
                *ngIf="
                  estampDetails.get('referenceNumber')?.hasError('maxlength')
                "
              >
                *Maximum 80 characters allowed
              </span>
              <span
                class="p-error"
                style="font-size: 0.8rem; display: block; padding-top: 0.2rem"
                *ngIf="
                  estampDetails
                    .get('referenceNumber')
                    ?.hasError('invalidChars') &&
                  estampDetails.get('referenceNumber')?.touched
                "
              >
                *Only alphabets, numbers, _ and - are allowed
              </span>
            </div>
          </div>

          <div
            formArrayName="documentDetailsForm"
            *ngIf="isEstamped"
            class="mt-3"
          >
            <section
              *ngFor="
                let details of documentDetailsArray().controls;
                let documentDetailsIndex = index
              "
              [formGroupName]="documentDetailsIndex"
            >
              <div class="form_outline_sty">
                <div *ngIf="contractType && isEstamped && showFields">
                  <form [formGroup]="additionalForm.at(documentDetailsIndex)">
                    <div class="form_outline_sty">
                      <strong class="m-1 mt-2 title_header_0"
                        >Financial Stamp Details</strong
                      >
                      <div class="row form_inputFields">
                        <div
                          *ngFor="let item of formData"
                          class="col-12 col-md-4"
                        >
                          <div *ngFor="let key of objectKeys(item)">
                            <div *ngIf="item[key]?.module === 'estamp'">
                              <ng-container [ngSwitch]="item[key]?.data_type">
                                <span class="form_field">{{
                                  item[key]?.label
                                }}</span>
                                <span
                                  class="color_red"
                                  *ngIf="item[key]?.mandatory"
                                  >*</span
                                >
                                <div class="flex_row custom-input">
                                  <input
                                    *ngSwitchCase="'text'"
                                    class="form-control"
                                    [formControlName]="key"
                                    [placeholder]="item[key]?.label"
                                    [type]="
                                      isNumberField(item[key]?.validators)
                                        ? 'number'
                                        : 'text'
                                    "
                                    pInputText
                                  />
                                </div>
                                <div class="flex_row custom-input">
                                  <select
                                    *ngSwitchCase="'dropdown'"
                                    [formControlName]="key"
                                    class="form-select"
                                  >
                                    <option value="" disabled selected>
                                      Select {{ item[key]?.label }}
                                    </option>
                                    <option
                                      *ngFor="let option of item[key]?.options"
                                      [value]="getOptionKey(option)"
                                    >
                                      {{ getOptionValue(option) }}
                                    </option>
                                  </select>
                                </div>
                                <div class="flex_row custom-input">
                                  <input
                                    *ngSwitchCase="'date'"
                                    type="date"
                                    pInputText
                                    class="form-control"
                                    [placeholder]="item[key]?.label"
                                    [formControlName]="key"
                                  />
                                </div>
                                <div
                                  *ngIf="
                                    additionalForm
                                      .at(documentDetailsIndex)
                                      .get(key)?.invalid &&
                                    (additionalForm
                                      .at(documentDetailsIndex)
                                      .get(key)?.touched ||
                                      submitted)
                                  "
                                  class="p-error"
                                  style="font-size: 0.5rem; margin-top: 0.5rem"
                                >
                                  *This {{ item[key]?.label }} is required.
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div *ngIf="contractType && isEstamped && showIndividualFields">
                  <form
                    [formGroup]="eStampAdditionalForm.at(documentDetailsIndex)"
                  >
                    <div class="form_outline_sty">
                      <strong class="m-1 mt-2 title_header_0"
                        >Financial Stamp Details</strong
                      >
                      <div class="row form_inputFields">
                        <div
                          *ngFor="let item of formEstampData"
                          class="col-12 col-md-4"
                        >
                          <div *ngFor="let key of objectKeys(item)">
                            <div *ngIf="item[key]?.module === 'estamp.stamp'">
                              <ng-container [ngSwitch]="item[key]?.data_type">
                                <span class="form_field">{{
                                  item[key]?.label
                                }}</span>
                                <span
                                  class="color_red"
                                  *ngIf="item[key]?.mandatory"
                                  >*</span
                                >
                                <div class="flex_row custom-input">
                                  <input
                                    *ngSwitchCase="'text'"
                                    class="form-control"
                                    [formControlName]="key"
                                    [placeholder]="item[key]?.label"
                                    [type]="
                                      isNumberField(item[key]?.validators)
                                        ? 'number'
                                        : 'text'
                                    "
                                    pInputText
                                  />
                                </div>
                                <div class="flex_row custom-input">
                                  <select
                                    *ngSwitchCase="'dropdown'"
                                    [formControlName]="key"
                                    class="form-select"
                                  >
                                    <option value="" disabled selected>
                                      Select {{ item[key]?.label }}
                                    </option>
                                    <option
                                      *ngFor="let option of item[key]?.options"
                                      [value]="getOptionKey(option)"
                                    >
                                      {{ getOptionValue(option) }}
                                    </option>
                                  </select>
                                </div>
                                <div class="flex_row custom-input">
                                  <input
                                    *ngSwitchCase="'date'"
                                    type="date"
                                    pInputText
                                    class="form-control"
                                    [placeholder]="item[key]?.label"
                                    [formControlName]="key"
                                  />
                                </div>
                                <div
                                  *ngIf="
                                    eStampAdditionalForm
                                      .at(documentDetailsIndex)
                                      .get(key)?.invalid &&
                                    (eStampAdditionalForm
                                      .at(documentDetailsIndex)
                                      .get(key)?.touched ||
                                      submitted)
                                  "
                                  class="p-error"
                                  style="font-size: 0.5rem; margin-top: 0.5rem"
                                >
                                  *This {{ item[key]?.label }} is required.
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <strong class="m-1 mt-2 title_header_0"
                  >E-stamp {{ documentDetailsIndex + 1 }}</strong
                >

                <div
                  class="row mb-2 mt-2 align-items-center"
                  *ngIf="service == 'MULTIPLE-STAMP'"
                >
                  <div
                    *ngIf="documentDetailsIndex != 0"
                    class="col-auto d-flex align-items-center"
                  >
                    <input
                      type="checkbox"
                      (change)="
                        useSamePreviousFile(
                          $event.target.checked,
                          documentDetailsIndex
                        )
                      "
                      formControlName="isUseSamePreviousFile"
                    />
                    <span class="form_field previous-file ms-2"
                      >Use Previous File</span
                    >
                  </div>
                  <div class="col-auto d-flex align-items-center">
                    <input
                      type="checkbox"
                      formControlName="documentToBeEstamp"
                      (change)="onDocumentToBeEstamp(documentDetailsIndex)"
                    />
                    <span class="form_field previous-file ms-2"
                      >Do you want the Document to be stamped ?</span
                    >
                  </div>
                </div>

                <div
                  class="col-lg-4 col-sm-12 col-md-6"
                  *ngIf="
                    !this.documentDetailsArray()
                      .at(documentDetailsIndex)
                      .get('isUseSamePreviousFile').value &&
                    service == 'MULTIPLE-STAMP'
                  "
                >
                  <div class="d-flex align-items-center">
                    <input
                      class="form-control"
                      hidden
                      type="file"
                      accept=".pdf"
                      (change)="onFileSelected($event, documentDetailsIndex)"
                      #fileInput
                    />
                    <button
                      type="button"
                      class="btn btn-outline-secondary selectFile"
                      (click)="openFileModal(documentDetailsIndex)"
                    >
                      {{
                        this.documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get("fileName").value || "Select File"
                      }}
                    </button>
                    <!-- Eye Preview Button next to button once file is uploaded -->
                    <button
                      *ngIf="this.documentDetailsArray().at(documentDetailsIndex).get('fileName')?.value"
                      type="button"
                      class="btn-preview-eye ms-2"
                      (click)="previewEstampDocument(documentDetailsIndex)"
                      pTooltip="Preview Document"
                      tooltipPosition="top"
                    >
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#612e86" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    </button>
                  </div>
                </div>

                <div
                  class="col-lg-4 col-sm-12 col-md-6"
                  *ngIf="
                    this.documentDetailsArray()
                      .at(documentDetailsIndex)
                      .get('isUseSamePreviousFile').value &&
                    service == 'MULTIPLE-STAMP' &&
                    this.documentDetailsArray().at(documentDetailsIndex).get('fileName')?.value
                  "
                >
                  <div class="d-flex align-items-center">
                    <button
                      type="button"
                      class="btn btn-outline-secondary selectFile"
                      disabled
                      style="opacity: 0.85; cursor: default;"
                    >
                      {{
                        this.documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get("fileName").value
                      }}
                    </button>
                    <!-- Eye Preview Button next to button once file is uploaded -->
                    <button
                      type="button"
                      class="btn-preview-eye ms-2"
                      (click)="previewEstampDocument(documentDetailsIndex)"
                      pTooltip="Preview Document"
                      tooltipPosition="top"
                    >
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#612e86" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    </button>
                  </div>
                </div>

                <!-- ===== FIELDS SECTION: State → Branch → Process By → then rest ===== -->
                <div
                  class="row form_inputFields"
                  *ngIf="isDocumentToBeEstamp(documentDetailsIndex)"
                >
                  <!-- 1. Select State -->
                  <div
                    class="col-lg-4 col-sm-12 col-md-6 estamp"
                    (click)="
                      readOnlyDefault[documentDetailsIndex] &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">Select State</span>
                    <span class="color_red">*</span>
                    <div style="display: block">
                      <app-dropdown
                        class="custom-dropdown"
                        [options]="stateData"
                        formControlName="selectedState"
                        dataKey="id"
                        [readonly]="
                          isSyncOffLocked(documentDetailsIndex) ||
                          (documentDetailsIndex !== 0 && readOnlyFields) ||
                          readOnlyDefault[documentDetailsIndex] ||
                          documentDetailsIndex !== 0
                        "
                        [ngClass]="{
                          grey_background:
                            isSyncOffLocked(documentDetailsIndex) ||
                            (documentDetailsIndex !== 0 && readOnlyFields) ||
                            readOnlyDefault[documentDetailsIndex] ||
                            documentDetailsIndex !== 0,
                        }"
                        placeholder="Select State"
                        [filter]="true"
                        filterBy="state_name"
                        (onChange)="setStateData(documentDetailsIndex)"
                        optionLabel="state_name"
                      ></app-dropdown>
                    </div>
                  </div>

                  <!-- 2. Select Branch -->
                  <div class="col-lg-4 col-sm-12 col-md-6 estamp">
                    <span class="form_field">Select Branch</span>
                    <span class="color_red">*</span>
                    <div style="display: block">
                      <app-dropdown
                        class="custom-dropdown"
                        [options]="branchData[0]"
                        formControlName="selectBranch"
                        dataKey="id"
                        placeholder="Select Branch"
                        [filter]="true"
                        [readonly]="
                          isSyncOffLocked(documentDetailsIndex) ||
                          (documentDetailsIndex !== 0 && readOnlyFields) ||
                          readOnlyDefault[documentDetailsIndex] ||
                          documentDetailsIndex !== 0
                        "
                        [ngClass]="{
                          grey_background:
                            isSyncOffLocked(documentDetailsIndex) ||
                            (documentDetailsIndex !== 0 && readOnlyFields) ||
                            readOnlyDefault[documentDetailsIndex] ||
                            documentDetailsIndex !== 0,
                        }"
                        filterBy="name"
                        optionLabel="name"
                        (onChange)="setDefaultBranch($event)"
                      ></app-dropdown>
                    </div>
                  </div>

                  <!-- 3. Process By -->
                  <div
                    class="col-lg-4 col-sm-12 col-md-6 estamp"
                    (click)="
                      readOnlyDefault[documentDetailsIndex] &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">Process By</span>
                    <span class="color_red">*</span>
                    <div style="display: block">
                      <div class="flex-col">
                        <app-dropdown
                          class="custom-dropdown"
                          [options]="processOptions"
                          formControlName="process_type"
                          [readonly]="
                            isOperationalNeslContract ||
                            isSyncOffLocked(documentDetailsIndex) ||
                            (documentDetailsIndex == 0 && readOnlyFields) ||
                            readOnlyDefault[documentDetailsIndex] ||
                            documentDetailsIndex !== 0
                          "
                          [ngClass]="{
                            grey_background:
                              isOperationalNeslContract ||
                              isSyncOffLocked(documentDetailsIndex) ||
                              (documentDetailsIndex == 0 && readOnlyFields) ||
                              readOnlyDefault[documentDetailsIndex] ||
                              documentDetailsIndex !== 0,
                          }"
                          placeholder="Select Process By"
                          optionLabel="label"
                          optionValue="value"
                          (onChange)="onProcessChange($event)"
                        ></app-dropdown>
                      </div>
                    </div>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('process_type')
                          ?.hasError('required')
                      "
                      >*Please select process type</span
                    >
                  </div>
                </div>

                <!-- Row 2: First Party, Second Party, Stamp Duty Paid By -->
                <div
                  class="row form_inputFields"
                  *ngIf="isDocumentToBeEstamp(documentDetailsIndex)"
                >
                  <div
                    class="col-lg-4 col-sm-12 col-md-6"
                    (click)="
                      readOnlyDefault[documentDetailsIndex] &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">
                      {{
                        showHdfcFields
                          ? "Borrower/s Names(As per HDFC Bank Sanctions letter)"
                          : "First Party Name"
                      }}</span
                    ><span class="color_red">*</span>
                    <input
                      class="form-control"
                      formControlName="firstPartyName"
                      placeholder="Enter first party name"
                      maxlength="50"
                      pInputText
                      type="text"
                      [readOnly]="
                        isSyncOffLocked(documentDetailsIndex) ||
                        (documentDetailsIndex == 0 && readOnlyFields) ||
                        readOnlyDefault[documentDetailsIndex]
                      "
                      [ngClass]="{
                        grey_background:
                          isSyncOffLocked(documentDetailsIndex) ||
                          (documentDetailsIndex == 0 && readOnlyFields) ||
                          readOnlyDefault[documentDetailsIndex],
                      }"
                      onkeypress="
                        return (
                          (event.charCode >= 65 && event.charCode <= 90) ||
                          (event.charCode >= 97 && event.charCode <= 122) ||
                          (event.charCode >= 48 && event.charCode <= 57) ||
                          event.charCode == 32
                        );
                      "
                      (paste)="handlePasteEvent($event)"
                    />
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('firstPartyName')
                          ?.hasError('required')
                      "
                      >*Enter First Name</span
                    >
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('firstPartyName')
                          ?.hasError('notOnlyNumbers')
                      "
                      >*Cannot be only numbers</span
                    >
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('firstPartyName')
                          ?.hasError('noLeadingSpaces')
                      "
                      >*Cannot start with spaces</span
                    >
                  </div>

                  <div
                    class="col-lg-4 col-sm-12 col-md-6 estamp"
                    (click)="
                      isSecondPartyNameLocked(documentDetailsIndex) &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">Second Party Name</span
                    ><span class="color_red">*</span>
                    <input
                      placeholder="Enter second party name"
                      class="form-control"
                      formControlName="secondPartyName"
                      pInputText
                      type="text"
                      maxlength="50"
                      [readOnly]="isSecondPartyNameLocked(documentDetailsIndex)"
                      [ngClass]="{
                        grey_background: isSecondPartyNameLocked(documentDetailsIndex),
                      }"
                      onkeypress="
                        return (
                          (event.charCode >= 65 && event.charCode <= 90) ||
                          (event.charCode >= 97 && event.charCode <= 122) ||
                          (event.charCode >= 48 && event.charCode <= 57) ||
                          event.charCode == 32
                        );
                      "
                      (paste)="handlePasteEvent($event)"
                      (input)="onSecondPartyNameInput(documentDetailsIndex, $event)"
                    />
                    <span
                      class="p-error grey_background"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('secondPartyName')
                          ?.hasError('required')
                      "
                      >*Enter Second Name</span
                    >
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('secondPartyName')
                          ?.hasError('notOnlyNumbers')
                      "
                      >*Cannot be only numbers</span
                    >
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('secondPartyName')
                          ?.hasError('noLeadingSpaces')
                      "
                      >*Cannot start with spaces</span
                    >
                  </div>

                  <div
                    class="col-lg-4 col-sm-12 col-md-6 estamp"
                    (click)="
                      isSyncFieldLocked(documentDetailsIndex) &&
                        readOnlyDefault[documentDetailsIndex] &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">Stamp Duty Paid By</span>
                    <span class="color_red">*</span>
                    <div style="display: block">
                      <app-dropdown
                        [options]="stampDutyPaidByOptions"
                        class="custom-dropdown"
                        [readonly]="isSyncFieldLocked(documentDetailsIndex)"
                        [ngClass]="{
                          grey_background: isSyncFieldLocked(documentDetailsIndex),
                        }"
                        placeholder="Select stamp duty paid by"
                        [autoDisplayFirst]="false"
                        optionLabel="name"
                        optionValue="code"
                        formControlName="stampDutyPaidBy"
                        (onChange)="onStampDutyPaidBySync(documentDetailsIndex)"
                      ></app-dropdown>
                    </div>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('stampDutyPaidBy')
                          ?.hasError('required')
                      "
                      >*Select Paid By</span
                    >
                  </div>
                </div>

                <!-- Row 3: Purpose, Article Number, Consideration Price, Stamp Duty Value -->
                <div
                  class="row form_inputFields"
                  *ngIf="isDocumentToBeEstamp(documentDetailsIndex)"
                >
                  <div
                    class="col-lg-4 col-sm-12 col-md-6"
                    (click)="
                      isSyncEditableFieldLocked(documentDetailsIndex) &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">Purpose Of Stamp Duty</span
                    ><span class="color_red">*</span>
                    <input
                      class="form-control"
                      formControlName="purposeOfStampDuty"
                      placeholder="Enter Purpose"
                      pInputText
                      type="text"
                      maxlength="200"
                      [readOnly]="isSyncEditableFieldLocked(documentDetailsIndex)"
                      [ngClass]="{
                        grey_background: isSyncEditableFieldLocked(documentDetailsIndex),
                      }"
                      (paste)="
                        onPasteDocumentInput(
                          $event,
                          'purposeOfStampDuty',
                          documentDetailsIndex
                        )
                      "
                    />
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('purposeOfStampDuty')
                          ?.hasError('required')
                      "
                      >*Enter purpose</span
                    >
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('purposeOfStampDuty')
                          ?.hasError('noLeadingSpaces')
                      "
                      >*Cannot start with spaces</span
                    >
                  </div>

                  <div class="col-lg-4 col-sm-12 col-md-6 estamp">
                    <span class="form_field">Article Number</span>
                    <span class="color_red">*</span>
                    <div style="display: block">
                      <app-dropdown
                        [options]="articles[documentDetailsIndex]"
                        class="custom-dropdown"
                        placeholder="Select Article Number"
                        [filter]="true"
                        filterBy="articleDisplay"
                        [autoDisplayFirst]="false"
                        optionLabel="articleDisplay"
                        optionValue="id"
                        formControlName="articleNumber"
                        [readonly]="isSyncEditableFieldLocked(documentDetailsIndex)"
                        [ngClass]="{
                          grey_background: isSyncEditableFieldLocked(documentDetailsIndex),
                        }"
                        (onChange)="
                          onArticleNumberChange($event, documentDetailsIndex)
                        "
                        appendTo="body"
                        styleClass="article-number-select"
                        panelStyleClass="article-number-panel"
                      ></app-dropdown>
                    </div>
                  </div>

                  <div
                    class="col-lg-4 col-sm-12 col-md-6"
                    (click)="
                      isConsiderationPriceLocked(documentDetailsIndex) &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">{{
                      showHdfcFields ? "Loan Amount" : "Consideration Price"
                    }}</span>
                    <span class="color_red">*</span>
                    <div class="flex-col">
                      <input
                        class="form-control"
                        formControlName="considerationPrice"
                        placeholder="Enter price"
                        pInputText
                        type="number"
                        (keypress)="numberOnlyForConsidPrice($event)"
                        (paste)="onPaste($event)"
                        (wheel)="preventNumberInputScroll($event)"
                        (ngModelChange)="
                          onConsiderationPriceInput(
                            $event,
                            documentDetailsIndex
                          )
                        "
                        (input)="
                          onConsiderationPriceSync(documentDetailsIndex, $event)
                        "
                        [min]="0"
                        [readOnly]="isConsiderationPriceLocked(documentDetailsIndex)"
                        [ngClass]="{
                          grey_background: isConsiderationPriceLocked(documentDetailsIndex),
                        }"
                      />
                      <span
                        class="price-in-words mt-2"
                        *ngIf="
                          considerationPriceInWords[documentDetailsIndex] !==
                          null
                        "
                      >
                        {{
                          considerationPriceInWords[documentDetailsIndex]
                            | numberToWordsWithCurrency
                        }}
                      </span>
                    </div>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .getRawValue().process_type === 'ON_THE_FLY' &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('considerationPrice')
                          ?.hasError('required')
                      "
                      >*Enter consideration price</span
                    >
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        selectedArticleAmount[documentDetailsIndex]
                          ?.min_consideration_amount &&
                        selectedArticleAmount[documentDetailsIndex]
                          ?.max_consideration_amount &&
                        (documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('considerationPrice')
                          ?.hasError('min') ||
                          documentDetailsArray()
                            .at(documentDetailsIndex)
                            .get('considerationPrice')
                            ?.hasError('max')) &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('process_type')?.value !== 'PRE_PROCUREMENT'
                      "
                    >
                      *Value should be between
                      {{
                        selectedArticleAmount[documentDetailsIndex]
                          .min_consideration_amount
                      }}
                      to
                      {{
                        selectedArticleAmount[documentDetailsIndex]
                          .max_consideration_amount
                      }}
                    </span>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        selectedArticleAmount[documentDetailsIndex]
                          ?.min_consideration_amount &&
                        !selectedArticleAmount[documentDetailsIndex]
                          ?.max_consideration_amount &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('considerationPrice')
                          ?.hasError('min') &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('process_type')?.value !== 'PRE_PROCUREMENT'
                      "
                    >
                      *Value should be above
                      {{
                        selectedArticleAmount[documentDetailsIndex]
                          .min_consideration_amount
                      }}
                    </span>
                    <span
                      class="p-error"
                      style="font-size: 0.6rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('considerationPrice')
                          ?.hasError('min') &&
                        (submitted ||
                          documentDetailsArray()
                            .at(documentDetailsIndex)
                            .get('considerationPrice')?.touched) &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('process_type')?.value !== 'PRE_PROCUREMENT'
                      "
                    >
                      *Value should be above
                      {{
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get("considerationPrice")?.errors?.min.min
                      }}
                    </span>
                    <span
                      class="p-error"
                      style="font-size: 0.6rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('considerationPrice')
                          ?.hasError('max') &&
                        (submitted ||
                          documentDetailsArray()
                            .at(documentDetailsIndex)
                            .get('considerationPrice')?.touched) &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('process_type')?.value !== 'PRE_PROCUREMENT'
                      "
                    >
                      *Value should not exceed
                      {{
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get("considerationPrice")?.errors?.max.max
                      }}
                    </span>
                  </div>
                </div>

                <!-- Row 4: Stamp Duty Value, HDFC fields, PAN, Execution Date -->
                <div
                  class="row form_inputFields"
                  *ngIf="isDocumentToBeEstamp(documentDetailsIndex)"
                >
                  <div
                    class="col-lg-4 col-sm-12 col-md-6 estamp"
                    (click)="
                      isStampDutyValueLocked(documentDetailsIndex) &&
                        showReadonlyMessage()
                    "
                  >
                    <span class="form_field">Stamp Duty Value</span
                    ><span class="color_red">*</span>
                    <div style="display: block">
                      <div class="flex-col">
                        <app-dropdown
                          [options]="
                            denominationData[documentDetailsIndex] || []
                          "
                          class="custom-dropdown"
                          placeholder="Select/Enter Stamp Duty Value"
                          [editable]="
                            !sync_second_party_and_price ||
                            isOnTheFlyAtIndex(documentDetailsIndex) ||
                            sync_second_party_and_price ||
                            !readOnlyDefault[documentDetailsIndex]
                          "
                          optionLabel="amount"
                          optionValue="amount"
                          formControlName="stampDutyValue"
                          (keypress)="numberOnly($event)"
                          [readonly]="false"
                          [ngClass]="{}"
                          (input)="
                            convertToNumber($event, documentDetailsIndex)
                          "
                          (paste)="onPaste($event)"
                          (onChange)="
                            onSelectStampAmount($event, documentDetailsIndex)
                          "
                        ></app-dropdown>
                        <span
                          class="price-in-words mt-2"
                          *ngIf="
                            stampAmountInWords[documentDetailsIndex] &&
                            stampAmountInWords[documentDetailsIndex] !== null &&
                            stampAmountInWords[documentDetailsIndex] !== 0
                          "
                        >
                          {{
                            stampAmountInWords[documentDetailsIndex]
                              | numberToWordsWithCurrency
                          }}
                        </span>
                      </div>
                    </div>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .getRawValue().process_type === 'ON_THE_FLY' &&
                        (documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('stampDutyValue')
                          ?.hasError('required') ||
                          stampAmountInWords[documentDetailsIndex] === 0 ||
                          stampAmountInWords[documentDetailsIndex] === null)
                      "
                      >*Enter stamp duty</span
                    >
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('stampDutyValue')
                          ?.hasError('min') &&
                        minStampValue[documentDetailsIndex] !== null
                      "
                    >
                      *Stamp duty cannot be less than
                      {{ minStampValue[documentDetailsIndex] }}
                    </span>
                  </div>

                  <div
                    *ngIf="showHdfcFields"
                    class="col-lg-4 col-sm-12 col-md-6"
                  >
                    <span class="form_field"
                      >Place of service (As per HDFC Bank Sanction letter)</span
                    ><span class="color_red">*</span>
                    <app-dropdown
                      [options]="placeData"
                      class="custom-dropdown"
                      placeholder="Select place"
                      [editable]="true"
                      optionLabel="name"
                      optionValue="code"
                      formControlName="place"
                      (onChange)="onSelectedPlace($event)"
                    ></app-dropdown>
                  </div>

                  <div
                    class="col-lg-4 col-sm-12 col-md-6 estamp"
                    *ngIf="
                      documentDetailsArray()
                        .at(documentDetailsIndex)
                        .get('process_type')?.value === 'ESBTR'
                    "
                  >
                    <span class="form_field">First Party PAN</span>
                    <span class="color_red">*</span>
                    <div style="display: block">
                      <input
                        type="text"
                        pInputText
                        formControlName="first_party_pan"
                        placeholder="ABCDE1234F"
                        class="w-full"
                        style="text-transform: uppercase"
                        [readOnly]="
                          readOnlyFields ||
                          readOnlyDefault[documentDetailsIndex]
                        "
                        [ngClass]="{
                          grey_background:
                            (documentDetailsIndex == 0 && readOnlyFields) ||
                            readOnlyDefault[documentDetailsIndex],
                        }"
                        (input)="
                          documentDetailsArray()
                            .at(documentDetailsIndex)
                            .get('first_party_pan')
                            .setValue($event.target.value.toUpperCase())
                        "
                      />
                    </div>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('first_party_pan')
                          ?.hasError('pattern')
                      "
                      >*Invalid PAN Format</span
                    >
                  </div>

                  <div
                    class="col-lg-4 col-sm-12 col-md-6 estamp"
                    *ngIf="
                      documentDetailsArray()
                        .at(documentDetailsIndex)
                        .get('process_type')?.value === 'ESBTR'
                    "
                  >
                    <span class="form_field">Second Party PAN</span>
                    <span class="color_red">*</span>
                    <div style="display: block">
                      <input
                        type="text"
                        pInputText
                        formControlName="second_party_pan"
                        placeholder="ABCDE1234F"
                        class="w-full"
                        style="text-transform: uppercase"
                        [readOnly]="
                          readOnlyFields ||
                          readOnlyDefault[documentDetailsIndex]
                        "
                        [ngClass]="{
                          grey_background:
                            (documentDetailsIndex == 0 && readOnlyFields) ||
                            readOnlyDefault[documentDetailsIndex],
                        }"
                        (input)="
                          documentDetailsArray()
                            .at(documentDetailsIndex)
                            .get('second_party_pan')
                            .setValue($event.target.value.toUpperCase())
                        "
                      />
                    </div>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('second_party_pan')
                          ?.hasError('pattern')
                      "
                      >*Invalid PAN Format</span
                    >
                  </div>

                  <div class="col-lg-4 col-sm-12 col-md-6 estamp">
                    <span class="form_field">Execution Date</span>
                    <span class="color_red">*</span>
                    <div class="d-flex align-items-center gap_5">
                      <div>
                        <p-datepicker
                          #calendar
                          class="custom-calendar w-full"
                          [ngClass]="{
                            grey_background:
                              sync_second_party_and_price &&
                              documentDetailsIndex !== 0,
                          }"
                          formControlName="execution_date"
                          [maxDate]="minDate"
                          placeholder="Select Date"
                          [showIcon]="true"
                          iconDisplay="input"
                          [readonlyInput]="
                            sync_second_party_and_price
                              ? documentDetailsIndex !== 0
                              : false
                          "
                          [disabled]="
                            sync_second_party_and_price
                              ? documentDetailsIndex !== 0
                              : false
                          "
                          inputId="dateformat"
                          dateFormat="dd/mm/yy"
                          (onSelect)="
                            onExecutionDateSync(documentDetailsIndex)
                          "
                        ></p-datepicker>
                      </div>
                      <div class="remove_btn">
                        <button
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-trash"
                          [disabled]="documentDetailsIndex < 1"
                          (click)="removeDetails(documentDetailsIndex)"
                          class="p-button-sm p-button-danger p-button-outlined"
                          style="height: 26px"
                        ></button>
                      </div>
                    </div>
                    <span
                      class="p-error"
                      style="font-size: 0.5rem"
                      *ngIf="
                        submitted &&
                        documentDetailsArray()
                          .at(documentDetailsIndex)
                          .get('execution_date')
                          ?.hasError('required')
                      "
                      >*Enter Date</span
                    >
                  </div>

                  <div
                    *ngIf="showPanCard[documentDetailsIndex]"
                    class="col-lg-4 col-sm-12 col-md-6"
                  >
                    <span class="form_field">Pan Card</span>
                    <div style="display: block">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="PAN number"
                        pInputText
                        required
                        name="PAN"
                        formControlName="panNumber"
                        pattern="[A-Z]{5}\d{4}[A-Z]"
                        [readOnly]="
                          readOnlyFields ||
                          readOnlyDefault[documentDetailsIndex]
                        "
                        [ngClass]="{
                          grey_background:
                            (documentDetailsIndex == 0 && readOnlyFields) ||
                            readOnlyDefault[documentDetailsIndex],
                        }"
                        (paste)="handlePasteEvent($event)"
                        maxlength="10"
                      />
                      <div
                        *ngIf="
                          documentDetailsArray()
                            .at(documentDetailsIndex)
                            .get('panNumber')
                            ?.hasError('required')
                        "
                        style="font-size: 0.6rem"
                      >
                        PAN number is required.
                      </div>
                      <div
                        *ngIf="
                          documentDetailsArray()
                            .at(documentDetailsIndex)
                            .get('panNumber')
                            ?.hasError('pattern')
                        "
                        style="font-size: 0.6rem"
                      >
                        Invalid PAN. PAN should be of 10 characters where first
                        five characters are letters, next four numeral and last
                        character is a letter.
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ===== END FIELDS SECTION ===== -->
              </div>
            </section>
          </div>

          <div
            class="flex-buttons mt-3"
            *ngIf="
              (isEstamped && !readOnlyDefault[0]) ||
              (isEstamped && isDefault == true)
            "
          >
            <div class="custom_button_1">
              <p-button
                label="Add new E-stamp"
                (click)="addNewDetails()"
                styleClass="p-button-sm-outline"
              ></p-button>
            </div>
          </div>

          <div
            *ngIf="
              pathId &&
              ((showPayment && process_type === 'ON_THE_FLY') || is_wallet)
            "
          >
            <div class="row mt-3">
              <p class="title_five" style="font-size: 1rem; color: black">
                Payment method
              </p>
            </div>
            <div class="flex_row mt-2">
              <div
                *ngIf="is_wallet && !isCatFlow"
                class="flex_row p-field-radiobutton radio_btn align-items-center"
              >
                <input
                  type="radio"
                  id="wallet"
                  name="paymentMethod"
                  (click)="paymentMethod(paymentbyWallet)"
                  formControlName="paymentMethod"
                  [value]="paymentbyWallet"
                />
                <label class="me-1 ms-1" style="font-size: 0.8rem" for="wallet"
                  >Wallet</label
                >
              </div>
              <ng-container
                *ngIf="pathId && showPayment && process_type === 'ON_THE_FLY'"
              >
                <div
                  *ngIf="hasProvider('RAZORPAY_GATEWAY')"
                  class="flex_row p-field-radiobutton radio_btn ms-3 align-items-center"
                >
                  <input
                    type="radio"
                    id="razorpay"
                    name="paymentMethod"
                    (click)="paymentMethod(paymentbyRazorpay)"
                    formControlName="paymentMethod"
                    [value]="paymentbyRazorpay"
                  />
                  <label class="me-1 ms-1 d-flex" for="razorpay">
                    <img
                      src="../../../assets/logos/razorpay_big_icon.svg"
                      class="razorpay-logo me-1"
                      alt="razorpay-logo"
                    />
                  </label>
                </div>
                <div
                  *ngIf="hasProvider('HDFC_GATEWAY')"
                  class="flex_row p-field-radiobutton radio_btn ms-3 align-items-center"
                >
                  <input
                    type="radio"
                    id="hdfc_gateway"
                    name="paymentMethod"
                    (click)="paymentMethod('HDFC_GATEWAY')"
                    formControlName="paymentMethod"
                    [value]="'HDFC_GATEWAY'"
                  />
                  <label
                    class="me-1 ms-1"
                    style="font-size: 0.8rem"
                    for="hdfc_gateway"
                  >
                    <img
                      src="../../../assets/logos/HDFClogo.png"
                      class="razorpay-logo me-1"
                      alt="hdfc-logo"
                    />
                  </label>
                </div>
                <div
                  *ngIf="!is_wallet"
                  class="flex_row p-field-radiobutton align-items-center radio_btn ms-3"
                >
                  <input
                    type="radio"
                    id="pay_later"
                    name="paymentMethod"
                    (click)="paymentMethod(payLater)"
                    formControlName="paymentMethod"
                    [value]="payLater"
                  />
                  <label
                    class="me-1 ms-1"
                    style="font-size: 0.8rem"
                    for="pay_later"
                    >Continue without payment</label
                  >
                </div>
              </ng-container>
            </div>
          </div>

          <div
            class="mt-2"
            *ngIf="
              pathId &&
              showPaymentDetails &&
              showPayment &&
              process_type === 'ON_THE_FLY'
            "
          >
            <div class="row form_inputFields form_outline_sty mt-2">
              <div class="col-lg-4 col-sm-4 col-md-4">
                <span class="form_field">Payee Name</span
                ><span class="color_red">*</span>
                <input
                  class="form-control edit_input"
                  formControlName="payeeName"
                  placeholder="Enter Name"
                  pInputText
                  type="text"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                    submitted &&
                    estampDetails.get('payeeName')?.hasError('required')
                  "
                  >*Enter Valid Name</span
                >
              </div>
              <div class="col-lg-4 col-sm-4 col-md-4">
                <span class="form_field">Payee Email</span
                ><span class="color_red">*</span>
                <input
                  class="form-control edit_input"
                  formControlName="payeeEmail"
                  placeholder="Enter Email"
                  pInputText
                  type="text"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                    submitted &&
                    estampDetails.get('payeeEmail')?.hasError('required')
                  "
                  >*Enter Valid Email</span
                >
              </div>
              <div class="col-lg-4 col-sm-4 col-md-4">
                <span class="form_field">Payee Contact</span
                ><span class="color_red">*</span>
                <input
                  class="form-control edit_input"
                  formControlName="payeeMobileNumber"
                  placeholder="Enter Number"
                  pInputText
                  type="text"
                  (keypress)="numberOnly($event)"
                  minlength="10"
                  maxlength="10"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                    submitted &&
                    estampDetails.get('payeeMobileNumber')?.hasError('required')
                  "
                  >*Enter Valid Mobile Number</span
                >
              </div>
            </div>
          </div>

          <div class="place-order-buttons mt-3">
            <div *ngIf="pathId" class="col-lg-2 col-sm-2 col-md-2 text-right">
              <p-button
                label="Place Order"
                styleClass="p-button-sm-outline"
                (click)="openValidatePopup()"
                [disabled]="!estampDetails.valid"
              ></p-button>
            </div>
          </div>

          <div class="flex_row mt-4">
            <div *ngIf="!pathId" class="col-lg-1 col-sm-1 col-md-1 text-left">
              <p-button
                [disabled]="service == 'MULTIPLE-STAMP'"
                label="Back"
                (click)="gotoTemplate()"
                styleClass="p-button-sm-outline"
              ></p-button>
            </div>
            <div class="col-lg-10 col-sm-10 col-md-10"></div>
            <div *ngIf="!pathId" class="col-lg-1 col-sm-1 col-md-1 text-right">
              <p-button
                label="Next"
                (click)="openValidatePopup()"
                styleClass="p-button-sm-outline"
                [disabled]="
                  (!areStampedDocumentsValid() && isEstamped) ||
                  isAnyRequiredFileMissing() ||
                  !isAnyDocumentToBeStampedSelected()
                "
              ></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #bulkOptionModalPopup let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Bulk Upload Option</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      ></button>
    </div>
    <div class="row p-3 ms-3">
      <p>
        If you have more than 5 E-stamp (or) E-sign, you can proceed with Bulk
        Upload option
      </p>
    </div>
    <div class="row mt-4">
      <div class="col-lg-6 col-sm-6 col-md-6" style="padding-left: 2rem">
        <div class="custom_button">
          <p-button
            label="Continue Anyway"
            (click)="cancelBulkOption()"
            styleClass="p-button-sm"
          ></p-button>
        </div>
      </div>
      <div class="col-lg-6 col-sm-6 col-md-6" style="padding-right: 2rem">
        <div class="text-right custom_button">
          <p-button
            label="Go to Bulk Upload"
            (click)="goToBulkUpload()"
            styleClass="p-button-sm-outline"
          ></p-button>
        </div>
      </div>
    </div>
    <div class="p-2"></div>
  </div>
</ng-template>

<div
  #validateModalPopup
  data-bs-toggle="modal"
  data-bs-target="#exampleModal"
></div>

<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="text-right p-3">
        <button
          #closeValidatePopupBtn
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="text-center py-2 pb-5">
        <p class="pop_style">
          You have not filled all the details.<br />Please enter all the details
          to proceed
        </p>
      </div>
      <div class="row">
        <div class="col-lg-5 col-sm-5 col-md-5"></div>
        <div class="col-lg-2 col-sm-2 col-md-2">
          <div class="text-right custom_button">
            <p-button
              label="Ok"
              (click)="closeValidatePopup()"
              styleClass="p-button-sm"
            ></p-button>
          </div>
        </div>
        <div class="col-lg-5 col-sm-5 col-md-5"></div>
      </div>
      <div class="p-2"></div>
    </div>
  </div>
</div>

<div
  #validateDataModalPopup
  data-bs-toggle="modal"
  data-bs-target="#dataConfirmModal"
></div>

<div
  class="modal fade"
  id="dataConfirmModal"
  tabindex="0"
  aria-labelledby="dataConfirmModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="text-right p-3">
        <button
          #closeDataConfirmPopupBtn
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="text-center py-2 pb-5">
        <p class="pop_style">Are you sure all these details are correct?</p>
      </div>
      <div class="container mb-5">
        <div class="mt-1 table_styleing">
          <table class="table table-borderless">
            <thead class="modal-bg align-middle">
              <tr class="modal-bg">
                <th class="modal-bg" scope="col">First Party</th>
                <th class="modal-bg" scope="col">Second Party</th>
                <th class="modal-bg" scope="col">Stamp Duty Value</th>
                <th class="modal-bg" scope="col">Branch</th>
                <th class="modal-bg" scope="col">Article</th>
                <th class="modal-bg" scope="col">Execution Date</th>
              </tr>
            </thead>
            <tbody class="tablebody">
              <tr
                style="margin-top: 20px"
                *ngFor="let order of estampDataForValidation"
              >
                <td>{{ order.value.firstPartyName }}</td>
                <td>{{ order.value.secondPartyName }}</td>
                <td>₹ {{ order.value.stampDutyValue }}</td>
                <td>{{ order.get("selectBranch")?.value?.name }}</td>
                <td>{{ order.value.article_code }}</td>
                <td>{{ order.getRawValue().execution_date | date: "dd/MM/yyyy" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="footer-yes-no">
        <div class="text-center custom_button">
          <p-button
            label="No"
            (click)="closeDataConfirmPopup()"
            styleClass="p-button-sm"
          ></p-button>
        </div>
        <div class="text-center custom_button">
          <p-button
            label="Yes"
            (click)="dataConformation()"
            styleClass="p-button-sm-outline"
          ></p-button>
        </div>
      </div>
      <div class="p-2"></div>
    </div>
  </div>
</div>

<!-- PrimeNG Modal for File Selection -->
<p-dialog
  [(visible)]="showFileModal"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="file-upload-modal"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h5 class="title_five fw-semibold">
        Upload Document <span class="text-danger">*</span>
      </h5>
      <button
        #closeUploadPopupBtn
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="cancelFileSelection()"
        style="margin-left: 27rem"
      ></button>
    </div>
  </ng-template>
  <div class="upload-section">
    <input
      #modalFileInput
      type="file"
      (change)="onModalFileSelected($event)"
      style="display: none"
    />
    <div class="px-1 py-1">
      <div
        class="upload-area"
        [class.drag-over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="modalFileInput.click()"
      >
        <div class="upload-content">
          <div class="upload-icon mb-2">
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="text-muted"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17,8 12,3 7,8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
          <h6 class="upload-title mb-2">Drop your files here</h6>
          <p class="upload-subtitle mb-2">
            or
            <span class="text-primary cursor-pointer text-decoration-underline"
              >click to select file</span
            >
          </p>
          <div class="upload-info">
            <small class="text-muted"
              >Supported format:<b> PDF, up to 15 MB</b></small
            >
          </div>
        </div>
      </div>
      <div class="selected-files mt-3">
        <div
          class="file-item d-flex align-items-center justify-content-between p-2 border rounded"
        >
          <div class="d-flex align-items-center">
            <svg
              width="20"
              height="20"
              class="text-green me-2"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
              />
            </svg>
            <span class="file-name">{{
              selectedFile ? selectedFile.name : "Selected File"
            }}</span>
          </div>
        </div>
      </div>
      <div>
        <span
          class="p-error"
          style="font-size: 0.65rem; margin-top: 10px"
          *ngIf="fileSizeError"
        >
          File size exceeds maximum limit of 15MB. Please upload a smaller file.
        </span>
      </div>
      <div class="d-flex justify-content-center gap-4 mt-3">
        <div
          class="cloud-service-icon"
          title="Google Drive"
          trackClick="click_google_drive"
          (click)="openGoogleDrive()"
        >
          <img
            src="assets/img/g-drive.png"
            alt="Google Drive"
            width="48"
            height="40"
          />
        </div>
        <div
          class="cloud-service-icon"
          title="Upload from Link"
          trackClick="click_upload_from_link"
          (click)="openLink(getCurrentDocumentIndex())"
        >
          <img
            src="assets/img/link.png"
            alt="Upload from Link"
            width="48"
            height="40"
          />
        </div>
        <div
          *ngIf="dropboxEnabled"
          class="cloud-service-icon"
          title="Dropbox"
          trackClick="click_dropbox"
          (click)="openDropbox(getCurrentDocumentIndex())"
        >
          <img
            src="assets/img/dropbox.png"
            alt="Dropbox"
            width="48"
            height="40"
          />
        </div>
        <div
          class="cloud-service-icon"
          title="OneDrive"
          trackClick="click_onedrive"
          (click)="openOneDrive(getCurrentDocumentIndex())"
        >
          <img
            src="assets/img/onedrive.png"
            alt="OneDrive"
            width="48"
            height="40"
          />
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="modal-footer border-0 pt-1">
      <button
        type="button"
        class="btn btn-outline-secondary me-2"
        (click)="cancelFileSelection()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="uploadFile()"
        [disabled]="!selectedFile"
      >
        Upload
      </button>
    </div>
  </ng-template>
</p-dialog>

<app-google-drive-modal
  [isVisible]="showGoogleDriveModal"
  (fileSelected)="onGoogleDriveFileSelected($event)"
  (modalClosed)="onGoogleDriveModalClosed()"
></app-google-drive-modal>
<app-upload-link
  [isVisible]="showLinkModal"
  (fileSelected)="onLinkFileSelected($event)"
  (modalClosed)="onLinkModalClosed()"
></app-upload-link>
<app-dropbox-modal
  *ngIf="dropboxEnabled"
  [isVisible]="showDropboxModal"
  (fileSelected)="onDropboxFileSelected($event)"
  (modalClosed)="onDropboxModalClosed()"
></app-dropbox-modal>
<app-onedrive-modal
  [isVisible]="showOneDriveModal"
  (fileSelected)="onOneDriveFileSelected($event)"
  (modalClosed)="onOneDriveModalClosed()"
></app-onedrive-modal>


<app-document-preview-modal
  [(isVisible)]="previewModalVisible"
  [file]="previewFile"
  [pdfSrc]="previewPdfSrc"
  [fileName]="previewFileName"
  [mode]="previewModalMode"
  [multiple]="false"
  (onUpload)="onEstampUploadConfirmed($event)"
  (onCancel)="onEstampUploadCancelled()"
  (onSave)="onEstampPreviewSaved($event)"
>
</app-document-preview-modal>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>
